"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _LottieOutroTrustPilotBase = _interopRequireDefault(require("../LottieOutroTrustPilotBase"));

var _all = require("animations-json/build/all");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var OutroTrustPilot01 = /*#__PURE__*/function (_AnimationBase) {
  _inherits(OutroTrustPilot01, _AnimationBase);

  var _super = _createSuper(OutroTrustPilot01);

  function OutroTrustPilot01(_ref) {
    var _this;

    var animationId = _ref.animationId,
        data = _ref.data,
        cdn = _ref.cdn;

    _classCallCheck(this, OutroTrustPilot01);

    var config = {
      default: {
        colors: ['#fff', '#000032']
      },
      inputs: [{
        key: 'title',
        type: 'string',
        dataPath: 'title',
        textTransform: 'none',
        maxLine: 1,
        maxCharInline: 33
      }, {
        key: 'text',
        type: 'string',
        dataPath: 'text',
        textTransform: 'none',
        maxLine: 3,
        maxCharInline: 50
      }, {
        key: 'customer_name',
        type: 'string',
        dataPath: 'consumer.displayName',
        textTransform: 'capitalize',
        maxLine: 1,
        maxCharInline: 1000
      }, {
        key: 'date',
        type: 'date',
        dataPath: 'createdAt',
        format: 'mmm d, yyyy'
      }, {
        key: 'stars',
        dataPath: 'businessUnit.stars',
        type: 'number'
      }, {
        key: 'average',
        dataPath: 'businessUnit.trustScore',
        type: 'number'
      }, {
        key: 'total',
        dataPath: 'businessUnit.numberOfReviews.total',
        type: 'number'
      }],
      width: 1280,
      height: 720,
      inDuration: 2000,
      intermissionDuration: 3000,
      outDuration: 0,
      totalDuration: 4400
    };
    _this = _super.call(this, 'OutroTrustPilot01', data, config);
    var animation = (0, _all.getAnimationJson)(animationId);
    animation = _this._setInputs(animation, data, config.inputs);
    animation = _this._setPackshot(animation, data, cdn);
    _this.json = JSON.parse(animation);
    return _this;
  }

  return OutroTrustPilot01;
}(_LottieOutroTrustPilotBase.default);

exports.default = OutroTrustPilot01;